@import "~/styles/v1/_variables.scss";

.Pager {
  .Previous,
  .Next {
    height: 29px;
    padding-top: 4px;

    &[disabled] {
      opacity: 1;
    }
  }

  .Previous {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  .Next {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  .Pages {
    border-color: $system_white-darker !important; // Override for borders from somewhere
    border-left: 0;
    border-right: 0;
    border-radius: 0;
    color: $system_eggplant-darker;
    cursor: default;

    &:hover {
      box-shadow: none;
    }

    &:active,
    &:focus {
      background: $system_white-lightest;
      border-left: 0;
      border-right: 0;
      color: $system_eggplant-darker;
    }
  }
}
